export default __webpack_public_path__ + "static/media/Img0008.5538472c.png";